import { FASTElement as L, attr as u, observable as C } from "@microsoft/fast-element";
import { pieChartStyles as T } from "./pie-chart.styles.js";
import { pieChartTemplate as I } from "./pie-chart.template.js";
import { Chart as $, ArcElement as R, DoughnutController as S, Tooltip as E } from "chart.js";
import { JsonValueConverter as w } from "../common/converters/json-value-converter.js";
import { designTokens as r } from "../design-tokens.js";
import { removeOpacityFromColor as k, addOpacityToColor as A } from "../common/color.js";
import { parseCssValue as y } from "../common/css-utils.js";
var O = Object.defineProperty, c = (x, i, t, e) => {
  for (var a = void 0, o = x.length - 1, s; o >= 0; o--)
    (s = x[o]) && (a = s(i, t, a) || a);
  return a && O(i, t, a), a;
}, h;
const l = (h = class extends L {
  constructor() {
    super(...arguments), this.defaultColorPalette = {
      // The categorical colors are new colors from new tokens, so these need to be
      // adjusted to use the tokens as soon as we have the color palette implementation
      categorical: [
        "#2391FC",
        "#28DEFF",
        "#4565E2",
        "#05E8C4",
        "#7062EA",
        "#57AFFF",
        "#046FD3",
        "#B0C0FF",
        "#00A188",
        "#00D0F5"
      ],
      sequential: [
        r.color.primary[400].$value,
        r.color.primary[300].$value,
        r.color.primary[200].$value,
        r.color.primary[100].$value,
        r.color.primary[90].$value,
        r.color.primary[80].$value,
        r.color.primary[70].$value,
        r.color.primary[60].$value,
        r.color.primary[50].$value,
        r.color.primary[40].$value
      ],
      diverging: [
        r.color.error[500].$value,
        r.color.error[400].$value,
        r.color.error[300].$value,
        r.color.error[200].$value,
        r.color.error[100].$value,
        r.color.neutral[90].$value,
        r.color.success[100].$value,
        r.color.success[200].$value,
        r.color.success[300].$value,
        r.color.success[400].$value,
        r.color.success[500].$value
      ]
    }, this.palette = "categorical", this.showLegend = !1, this.showTotal = !1, this.legendPosition = "bottom", this.fallbackLegendPosition = "bottom", this.cutout = "0", this.size = "md", this.data = [], this.chartData = [], this.tooltipRef = null, this.tooltip = {
      title: "",
      label: ""
    };
  }
  paletteChanged() {
    this.$fastController.isConnected && (this.updateChartData(), this.drawPieChart());
  }
  showTotalChanged() {
    this.$fastController.isConnected && (this.updateChartData(), this.drawPieChart());
  }
  onLegendKeyDown(i) {
    const t = i.event, e = t.key, a = this.legendItems.indexOf(
      t.target
    );
    if (e === "ArrowUp" || e === "ArrowLeft" || e === "Tab" && t.shiftKey) {
      const o = a - 1;
      o >= 0 && (h.updateHover(o, this.chart), this.legendItems[o].focus());
    } else if (e === "ArrowDown" || e === "ArrowRight" || e === "Tab") {
      const o = a + 1;
      o < this.chartData.length && (h.updateHover(o, this.chart), this.legendItems[o].focus()), e === "Tab" && a === this.chartData.length - 1 && this.legendItems[a].blur();
    }
  }
  cutoutChanged() {
    this.$fastController.isConnected && this.drawPieChart();
  }
  dataChanged() {
    this.$fastController.isConnected && (this.updateChartData(), this.drawPieChart());
  }
  tooltipOptionsChanged() {
    this.$fastController.isConnected && this.drawPieChart();
  }
  legendItemsChanged() {
    if (this.legendItems.length > 0) {
      const i = this.legendItems.reduce(
        (t, e) => t && t.clientWidth > e.clientWidth ? t : e
      ).clientWidth + 4;
      this.legendItems.forEach((t) => {
        t.style.width = i + "px";
      });
    }
  }
  updateChartData() {
    const i = this.defaultColorPalette[this.palette].slice();
    if (!(this.data != null && this.data.length > 0)) {
      this.chartData = [];
      return;
    }
    const t = JSON.parse(JSON.stringify(this.data)), e = this.getArcData();
    t.forEach((a, o) => {
      a.color == null && (a.color = i[o % i.length]), a.value = e[o];
    }), this.chartData = t;
  }
  // Helper function to convert given values to usable values for the arcs (e.g. too low values get bumped to the min size)
  getArcData() {
    const e = this.data.map((o) => o.value).slice(), a = e.reduce(
      (o, s) => o + s,
      0
    );
    for (let o = 0; o < e.length; o++)
      e[o] = e[o] * 360 / a, e[o] < 2 && (e[o] = 2);
    return e;
  }
  connectedCallback() {
    super.connectedCallback(), h._resizeObserver.observe(this), $.register(R, S, E), $.defaults.font.family = r.fontFamily.sans.$value, this.$fastController.isConnected && (this.chartLegendPosition = this.legendPosition, this.updateChartData(), this.drawPieChart());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), h._resizeObserver.unobserve(this);
  }
  static onResize(i) {
    var t, e, a, o, s, n, f, g, m, d, b;
    for (const v of i) {
      const p = v.target;
      (((e = (t = p.shadowRoot) == null ? void 0 : t.querySelector(".legend-list")) == null ? void 0 : e.scrollHeight) || 0) > (((o = (a = p.shadowRoot) == null ? void 0 : a.querySelector(".legend-list")) == null ? void 0 : o.clientHeight) || 0) ? (n = (s = p.shadowRoot) == null ? void 0 : s.querySelector(".legend-list")) == null || n.classList.add("legend-list-border") : (g = (f = p.shadowRoot) == null ? void 0 : f.querySelector(".legend-list")) == null || g.classList.remove("legend-list-border"), ((m = v.borderBoxSize) == null ? void 0 : m[0].inlineSize) - (((b = (d = p.shadowRoot) == null ? void 0 : d.querySelector(".legend-item")) == null ? void 0 : b.clientWidth) || 0) <= 240 && (p.legendPosition === "left" || p.legendPosition === "right") ? p.chartLegendPosition = p.fallbackLegendPosition : p.chartLegendPosition = p.legendPosition;
    }
  }
  static resetHover(i) {
    const t = i.config.data.datasets[0], e = t.backgroundColor, a = i.canvas.getRootNode().querySelectorAll(".legend-item");
    for (let o = 0; o < t.data.length; o++)
      e[o] = k(e[o]), a[o] && (a[o].classList.remove("non-highlight"), a[o].classList.remove("highlight"));
    t.backgroundColor = e, i.update();
  }
  resetHover() {
    h.resetHover(this.chart);
  }
  static updateHover(i, t) {
    const e = t.config.data.datasets[0], a = e.backgroundColor, o = t.canvas.getRootNode().querySelectorAll(".legend-item");
    for (let s = 0; s < e.data.length; s++)
      s == i ? (a[s] = k(a[s]), o[s] && (o[s].classList.remove("non-highlight"), o[s].classList.add("highlight"))) : (a[s] = A(a[s], 0.4), o[s] && (o[s].classList.remove("highlight"), o[s].classList.add("non-highlight")));
    e.backgroundColor = a, t.update();
  }
  onContextMenu(i) {
    i.event.preventDefault();
  }
  onLegendItemMouseover(i, t) {
    const a = this.chart.getDatasetMeta(0).data[t].tooltipPosition(!0), o = new MouseEvent("mousemove", {
      clientX: a.x,
      clientY: a.y
    });
    this.chart.canvas.dispatchEvent(o);
  }
  onLegendItemMouseout() {
    this.chart.canvas.dispatchEvent(
      new MouseEvent("mouseout", {
        clientX: this.chart.canvas.clientLeft + this.chart.canvas.clientWidth / 2,
        clientY: this.chart.canvas.clientTop + this.chart.canvas.clientHeight / 2
      })
    );
  }
  getTooltipLabel(i) {
    const t = this.data[i.dataIndex].value;
    let e = "";
    if (this.tooltipOptions.value && (e += t, this.dataType && (e += " " + (t === 1 ? this.dataType.singular : this.dataType.plural))), this.tooltipOptions.value && this.tooltipOptions.percentage && (e += " - "), this.tooltipOptions.percentage) {
      const a = this.data.reduce(
        (s, n) => s + n.value,
        0
      ), o = t * 100 / a;
      e += (o >= 0.1 ? o.toFixed(1) : "<0.1") + "%";
    }
    return e;
  }
  showTooltip(i, t, e) {
    var g;
    const a = (g = this.shadowRoot) == null ? void 0 : g.querySelector(".tooltip");
    if (!a)
      return;
    const o = a.clientWidth, s = a.clientHeight, n = i - o / 2 + y(r.spacing[5].$value), f = t - s / 2 - y(r.spacing[5].$value);
    a.style.left = `${n}px`, a.style.top = `${f}px`, a.style.wordBreak = "break-word", this.tooltip = {
      title: e.dataPoints[0].label,
      label: e.dataPoints[0].formattedValue
    }, a.style.opacity = "0.95", a.ariaHidden = "false";
  }
  hideTooltip() {
    var t;
    const i = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".tooltip");
    i && (i.style.opacity = "0", i.ariaHidden = "true");
  }
  drawPieChart() {
    const i = {
      labels: this.chartData.map((t) => t.label),
      datasets: [
        {
          data: this.chartData.map((t) => t.value),
          backgroundColor: this.chartData.map((t) => t.color),
          hoverOffset: y(r.spacing[3].$value),
          borderWidth: y(r.borderWidth.xs.$value),
          hoverBorderWidth: 0
        }
      ],
      showTotal: this.showTotal
    };
    this.chart && this.chart.destroy(), this.chart = new $(this.canvas, {
      type: "doughnut",
      data: i,
      options: {
        events: ["contextmenu", "mousemove", "click", "mouseout", "keydown"],
        responsive: !0,
        maintainAspectRatio: !1,
        aspectRatio: 1,
        offset: 0,
        spacing: 0,
        cutout: this.cutout,
        plugins: {
          legend: {
            display: !1
          },
          tooltip: {
            enabled: !1,
            external: (t) => {
              const e = t.tooltip;
              if (!(!this.chart || !this.tooltipRef)) {
                if (!e.opacity) {
                  this.hideTooltip();
                  return;
                }
                this.showTooltip(
                  e.caretX,
                  e.caretY,
                  e
                );
              }
            }
          }
        },
        layout: {
          padding: y(r.spacing[2].$value)
        },
        onHover: function(t, e, a) {
          e && e[0] ? h.updateHover(e[0].index, a) : h.resetHover(a);
        },
        onClick: function(t, e, a) {
          var o;
          if (e && e[0]) {
            const s = e[0].index;
            if (t.type === "click") {
              const n = new CustomEvent("left-click", {
                detail: { index: s },
                bubbles: !0,
                composed: !0
              });
              a.canvas.dispatchEvent(n);
            }
            if (t.type === "contextmenu") {
              (o = t.native) == null || o.preventDefault();
              const n = new CustomEvent("right-click", {
                detail: { index: s },
                bubbles: !0,
                composed: !0
              });
              a.canvas.dispatchEvent(n);
            }
          }
        }
      },
      plugins: [
        {
          // This workaround-plugin is necessary as mouseout only triggers directly on the chartArea since v3.1.0
          id: "ResetHoverOnMouseOut",
          beforeEvent(t, e) {
            e.event.type === "mouseout" && h.resetHover(t);
          }
        },
        {
          id: "DoughnutTotalOrEmpty",
          beforeDatasetsDraw: function(t) {
            var m;
            const {
              chartArea: { left: e, top: a, right: o, bottom: s },
              ctx: n
            } = t, f = (e + o) / 2, g = (a + s) / 2;
            if (t.data.datasets[0].data.length === 0) {
              const d = Math.min(o - e, s - a) / 2;
              n.beginPath(), n.lineWidth = t.height / 8, n.strokeStyle = r.color.neutral[70].$value, n.arc(
                f,
                g,
                d - 80 > t.height / 8 ? d - 80 : t.height / 8,
                0,
                2 * Math.PI
              ), n.stroke();
            }
            if (t.data.datasets[0].data.length === 0 || ((m = t.config.options) == null ? void 0 : m.cutout) != "0" && t.data.showTotal) {
              const { ctx: d, data: b } = t;
              if (d.save(), d.textBaseline = "middle", d.textAlign = "center", d.fillStyle = r.color.neutral[400].$value, t.data.datasets[0].data.length === 0) {
                const v = (t.height / 250).toFixed(2);
                d.font = "bold " + v + "rem sans-serif", d.fillText("No Data", f, g);
              } else {
                const v = (t.height / 200).toFixed(2);
                d.font = "bold " + v + "rem sans-serif";
                const p = b.datasets[0].data.reduce((P, D) => P + D);
                d.fillText(p.toString(), f, g);
              }
              d.restore();
            }
          }
        }
      ]
    });
  }
}, h.definition = {
  name: "pie-chart",
  template: () => I,
  styles: () => T
}, h._resizeObserver = new ResizeObserver(h.onResize), h);
c([
  u
], l.prototype, "palette");
c([
  u({ mode: "boolean" })
], l.prototype, "showLegend");
c([
  u({ mode: "boolean" })
], l.prototype, "showTotal");
c([
  u
], l.prototype, "legendPosition");
c([
  u
], l.prototype, "fallbackLegendPosition");
c([
  u
], l.prototype, "cutout");
c([
  u
], l.prototype, "size");
c([
  u({
    converter: w
  })
], l.prototype, "dataType");
c([
  u({
    converter: w
  })
], l.prototype, "tooltipOptions");
c([
  u({
    converter: w
  })
], l.prototype, "data");
c([
  u({
    converter: w
  })
], l.prototype, "accessibility");
c([
  C
], l.prototype, "chartData");
c([
  C
], l.prototype, "legendItems");
c([
  C
], l.prototype, "tooltipRef");
c([
  C
], l.prototype, "chartLegendPosition");
c([
  C
], l.prototype, "tooltip");
let X = l;
export {
  X as PieChart
};
